export enum ClientLabel {
    HubEntreprendre = 'Hub entreprendre',
    AdhesionSudDeFrance = 'Adhésion Sud de France',
    Afeo = 'Affiliation Fabriqué En Occitanie',
    AidesEnLigne = 'Mes aides en ligne'
}
